import request from '@/utils/request'

export function addCustomer(data) {
  return request({
    url: '/customer',
    method: 'post',
    data
  })
}

export function findCustomerList(data) {
  return request({
    url: '/customer/list',
    method: 'post',
    data
  })
}

export function deleteCustomerById(id) {
  return request({
    url: `/customer/${id}`,
    method: 'delete',
  })
}

export function findCustomerById(id) {
  return request({
    url: `/customer/${id}`,
    method: 'get',
  })
}

export function modifyCustomer(data) {
  return request({
    url: '/customer',
    method: 'put',
    data
  })
}

export function removeBsContactCustomer(id) {
  return request({
    url: `/customer/removeBsContactCustomer/${id}`,
    method: 'delete',
  })
}

export function removeBsCustomerAccount(id) {
  return request({
    url: `/customer/removeBsCustomerAccount/${id}`,
    method: 'delete',
  })
}
export function removeBsCustomerInformation(id) {
  return request({
    url: `/customer/removeBsCustomerInformation/${id}`,
    method: 'delete',
  })
}
